import { dollars, csvText } from './shared';

// Generic exports for Xero, Sage, Excel, or an accountant who maps columns
// themselves. The long format is one row per journal line (balanced per
// Journal No); the summary is one row per store per period.

export const JOURNAL_HEADER = ['Date', 'Journal No', 'Store', 'Class', 'Account', 'Debit', 'Credit', 'Description', 'Memo', 'Note'];

const note = (l) => (!l.mapped ? 'unmapped tender — default account used' : l.kind === 'overShort' ? 'balancing line' : '');

export function buildJournalCsv(entries) {
  const rows = [JOURNAL_HEADER];
  for (const e of entries) {
    for (const l of e.lines || []) {
      if (l.amount === 0) continue;
      rows.push([
        e.periodEnd, e.docNum, e.store, e.class || '', l.account,
        l.side === 'debit' ? dollars(l.amount) : '',
        l.side === 'credit' ? dollars(l.amount) : '',
        l.label, e.memo, note(l),
      ]);
    }
  }
  return csvText(rows);
}

// One row per store-period with a column per tender and per tax label seen
// anywhere in the export, so the sheet is rectangular.
export function buildJournalSummaryCsv(entries) {
  const tenders = [...new Set(entries.flatMap(e => e.lines.filter(l => l.kind === 'tender').map(l => l.tender)))];
  const taxes = [...new Set(entries.flatMap(e => e.lines.filter(l => /^tax[123]$/.test(l.kind)).map(l => l.label)))];
  const header = ['Store', 'Period', 'Period end', 'Journal No', 'Orders', 'Net sales',
    ...tenders.map(t => `Taken — ${t}`), ...taxes, 'Tips payable', 'Gift cards sold', 'Refunds', 'Discounts',
    'Total debits', 'Total credits', 'Over/short',
    // online vs in-store: separate merchant accounts
    'Online orders', 'Online net sales', 'Online taxes', 'Online tips', 'Online taken',
    'In-store orders', 'In-store net sales', 'In-store taxes', 'In-store tips', 'In-store taken'];
  const rows = [header];
  for (const e of entries) {
    const by = (pred) => e.lines.filter(pred).reduce((a, l) => a + l.amount, 0);
    const ch = (k) => e.channels?.[k] || { orders: 0, netSales: 0, taxes: 0, tips: 0, gross: 0 };
    rows.push([
      e.store, e.periodLabel || e.period, e.periodEnd, e.docNum, e.orders ?? '', dollars(e.netSales ?? by(l => l.kind === 'sales')),
      ...tenders.map(t => dollars(by(l => l.kind === 'tender' && l.tender === t))),
      ...taxes.map(t => dollars(by(l => /^tax[123]$/.test(l.kind) && l.label === t))),
      dollars(by(l => l.kind === 'tips')),
      dollars(by(l => l.kind === 'giftcard')),
      dollars(by(l => l.kind === 'refund')),
      dollars(by(l => l.kind === 'discount')),
      dollars(e.debits), dollars(e.credits), dollars(e.overShort),
      ...['online', 'instore'].flatMap(k => [ch(k).orders, dollars(ch(k).netSales), dollars(ch(k).taxes), dollars(ch(k).tips), dollars(ch(k).gross + ch(k).tips)]),
    ]);
  }
  return csvText(rows);
}
